
<!-- Инфляция -->

<template>

	<div class="mt-3">
		<!-- МУ п. 46.3. Формула расчета прибыли предпринимателя: -->
		<!-- <div class="my-3"><img :src="formula" /></div>
		<b-card no-body >
			<b-card-header header-tag="header" class="p-1" role="tab">
				<b-button block v-b-toggle="'accordion-' + _uid" variant="grey" style="text-align: left;"
					class="d-flex justify-content-between"
				>
						Описание
                        <b-icon-chevron-double-up class="when-opened" />
                        <b-icon-chevron-double-down class="when-closed" />
				</b-button>
			</b-card-header>
			<b-collapse :id="'accordion-' + _uid" accordion="my-accordion" role="tabpanel">
				<b-table :fields="desc_fields" :items="formula_desc" thead-class="d-none" class="m-0">
					<template v-slot:cell()="data">
						<span v-html="data.value"></span>
					</template>
				</b-table>
			</b-collapse>
		</b-card> -->

		<div class="d-flex justify-content-between align-items-center mt-3 navbar px-0">
			<div class="navbar_brand"><h4>Показатели прибыли предпринимателя</h4></div>

			<b-nav v-if="check_roles([ 'model' ]) && !not_editable" pills class="justify-content-end">
	
				<b-button v-on:click="() => evaluate_inflation()" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Рассчитать прибыль предпринимателя'"><base-icon name="calc" /></b-button>
	
			</b-nav>
		</div>


		<b-container fluid style="overflow-x:auto;" class="p-0">

			<b-overlay :show="wait">
			<b-table ref="table" id="table" hover :items="data" :fields="fields">

				<template v-slot:cell()="data">

					<div v-if="data.field.key == 'project_period' || data.field.key == 'building_period'">{{ data.value }}</div>
					<div v-else-if="data.field.key == 'coef'">{{ (data.item.pp / 100 + 1).toFixed(3) }}</div>
                    <table_input v-else
                        :value="data.value" :item="data.item"
                        v-on:change="value => set_inflation(data.item.project_period, data.item.building_period, value)"
                        :validation="check" :readonly="!check_roles([ 'model' ]) || not_editable"
                    />
					

				</template>

			</b-table>
			</b-overlay>

		</b-container>

	</div>

</template>

<script>

import api from "../../../../../../api"
import formula from "./formules/profit.svg"
import table_input from "../../../../../widgets/table_input"

export default
{	
	props :
	{
		id : String,
		data : Array,
		not_editable : Boolean,
	},

	components :
	{
		table_input
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			fields :
			[
				{ key : "project_period", label : "Период проектирования (квартал)", tdClass : "text-right" },
				{ key : "building_period", label : "Период строительства (квартал)", tdClass : "text-right" },
				{ key : "pp", label : "Прибыль предпринимателя (%)" },
			],

			wait : false,

			formula,

			desc_fields :
			[
				{ key : "name", label : "", tdClass : "formula_cell", },
				{ key : "desc", label : "", tdClass : "formula_cell", }
			],

			formula_desc:
			[
				{ name : "ПП", desc : "Прибыль предпринимателя (%)", },
				{ name : "<i>&Delta;<sub>зу</sub></i>", desc : "Величина авансового платежа, связанного с созданием объекта, в том числе стоимость прав на земельный участок", },
				{ name : "1", desc : "Поправочный коэффициент", },
				{ name : "<i>Y</i>", desc : "Норма доходности для инвестиций в строительство (% в рассматриваемый период (месяц, квартал, год)", },
				{ name : "<i>n</i>", desc : "Количество периодов инвестирования (продолжительность строительства)", },
				{ name : "<i>i</i>", desc : "Корядковый номер периода", },
			],
			
			check :
			{
				check : (value) => api.check_number({ value : value, accuracy : 2, gte : 0 }),
				msg : "Больше или равно 0, до 2-х знаков после запятой"
			}
		}
	},

	methods :
	{
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },
		
		set_inflation(project_period, building_period, value)
		{
			var new_arr = this.data.map(
				(element) =>
				element.project_period == project_period && element.building_period == building_period
				? {...element, pp : value}
				: element
			)
			this.$emit('set_value', new_arr)
		},

		evaluate_inflation()
		{
			if (this.check_roles([ 'model' ]) && !this.not_editable)
			{
				api.call(this, this.service, "evaluate_inflation", { id : this.id },
					() =>
					{
						api.show_notification(this, "Расчет прибыли предпринимателя завершен")

						this.$emit("need_refresh")
					})
			}
		},
	}
}

</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>
